const ActivityIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.7273 21.1818C14.3636 21.1818 14 20.9091 13.9091 20.5455L9.27273 6.81818L7.36364 12.4545C7.27273 12.7273 6.90909 13 6.54545 13H2.90909C2.36364 13 2 12.6364 2 12.0909C2 11.5455 2.36364 11.1818 2.90909 11.1818H5.90909L8.45455 3.63636C8.54545 3.27273 8.90909 3 9.27273 3C9.63636 3 10 3.27273 10.0909 3.63636L14.7273 17.3636L16.6364 11.7273C16.7273 11.3636 17.0909 11.0909 17.4545 11.0909H21.0909C21.6364 11.0909 22 11.4545 22 12C22 12.5455 21.6364 12.9091 21.0909 12.9091H18.0909L15.5455 20.4545C15.4545 20.9091 15.0909 21.1818 14.7273 21.1818Z" fill="#5B36F2" />
        </svg>
    );
}

export default ActivityIcon;